export default class Review {
  constructor(node) {
    this.element = node;
    this.reviewStars = this.element.querySelectorAll(".js-review-star");
    this.reviewStarsWrapper = this.element.querySelector(".js-review-star-wrapper");
    this.input = this.element.querySelector(".js-review-input");

    this.initialize();
  }

  initialize() {
    this.reviewStarsWrapper.addEventListener("click", (e) => {
      const currentTarget = e.target;

      if (currentTarget.classList.contains("js-review-star")) {
        this.highlightStars(currentTarget, e.x);
      }
    });
  }

  highlightStars(currentStar, x) {
    const currentStarIndex = Array.from(this.reviewStars).indexOf(currentStar);

    this.reviewStars.forEach((star, index) => {
      star.classList.remove("filled", "half");
      if (index < currentStarIndex) {
        star.classList.add("filled");
      } else if (index === currentStarIndex) {
        if (x < star.getBoundingClientRect().left + star.offsetWidth / 2) {
          this.input.value = currentStarIndex + 0.5;
          star.classList.add("half");
        } else {
          this.input.value = currentStarIndex + 1;
          star.classList.add("filled");
        }
      }
    });
  }
}
